import accessControlled from "components/access-control/access-controlled";
import ViewAccessMethods from "ViewAccessMethods";
import SIconButton from "./SIconButton";

const AdminSIconButton = accessControlled(SIconButton, ViewAccessMethods.hasAdminAccess);

export default AdminSIconButton;
